import {merge} from '#core/utils/config-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {BasePalette} from '#core/application/modules/base-palette.js';

import {generateToggleButton} from '../button/toggle-button/index.js';
import {generateSelectableButtonVerticalList} from '../list-item/index.js';

import SETTINGS_SCHEMA from './settings.palette-schema.yaml';

registerTileSchema(SETTINGS_SCHEMA);

export function generateSettingMenuGlobalStuff(TILE) {
    const EXPANDABLE_VIEW = {
        rotation: {
            image: {
                style: {
                    fill: TILE.SETTINGS_ITEM_EXPAND_ICON,
                    minWidth: 8,
                    minHeight: 8,
                },
            },
        },
        contentContainer: {
            style: {
                base: {
                    padding: 0,
                },
            },
        },
        headerContainer: {
            style: {
                base: {
                    padding: 8,
                    minHeight: 40,
                },
            },
        },
        headerTextContainer: {
            style: {
                ...TILE.SETTINGS_ITEM_TEXT,
            },
        },
        expandIconPosition: 'right',
    };

    return {
        SettingsMenuClassic: {
            additionalLinks: {
                button: {
                    style: {
                        base: {
                            padding: 8,
                        },
                    },
                },
                label: {
                    style: TILE.SETTINGS_ADDITIONAL_LINK.TERTIARY_LINK_TEXT,
                },
                chevron: {
                    style: {
                        fill: TILE.SETTINGS_ADDITIONAL_LINK.TERTIARY_LINK_ICON_COLOR,
                    },
                },
            },
            style: {
                sectionHeader: {
                    textTransform: 'capitalize',
                    padding: 8,
                    _mobile_padding: '0 8px 8px',
                    ...TILE.SETTINGS_SECTION_HEADER_TEXT,
                },
            },
            container: {
                style: {
                    fontFamily: BasePalette.palette.FONT_FAMILY,
                },
            },
        },
        LanguageSelector: {
            languageButtons: {
                selectableButton: generateSelectableButtonVerticalList(TILE.SETTINGS_LANGUAGE_SELECTOR),
            },
            expandable: EXPANDABLE_VIEW,
        },
        OddsSelector: {
            oddsItem: generateSelectableButtonVerticalList(TILE.SETTINGS_ODDS_FORMAT_SELECTOR),
            oddsList: {
                itemSpacing: '4px',
            },
            expandable: merge(EXPANDABLE_VIEW, {
                container: {
                    separator: {
                        style: {
                            margin: 5,
                        },
                    },
                },
            }),
        },
        TimeOffsetSelector: {
            expandable: merge(EXPANDABLE_VIEW, {
                contentContainer: {
                    style: {
                        base: {
                            margin: '0 8px',
                        },
                    },
                },
            }),
            fullRowOffsetButton: generateToggleButton(TILE.SETTINGS_TIMEZONE_BUTTON),
            offsetButton: generateToggleButton(TILE.SETTINGS_TIMEZONE_BUTTON),
            rowSeparator: {
                style: {
                    size: 4,
                },
            },
            columnSeparator: {
                style: {
                    size: 4,
                },
            },
        },
    };
}
